import { all } from 'redux-saga/effects';
import commonSagas from './CommonSagas';

export default function* rootSaga() {
  yield all([
    commonSagas(),
  ]);
}
